import {Component, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {BaseComponent} from "../../base.component";
import {LoggerService} from "../../common/logger.service";
import {UserService} from "../../common/user.service";
import {ActivatedRoute} from "@angular/router";
import * as _ from "lodash";
import {IMarketingPage} from "../marketing-page.models";
import {MarketingPageService} from "../marketing-page.service";
import {Constants} from "../../constants";
import {MarketingPageFactoryService} from "../marketing-page-factory.service";

@Component({
    templateUrl: './high-conversion-page.component.html',
    standalone: false
})
export class HighConversionPageComponent extends BaseComponent implements OnInit {

    @ViewChild('dynamicPage', {read: ViewContainerRef}) viewContainerRef: ViewContainerRef;
    marketingPageId: string;
    marketingPage: IMarketingPage = {modules: []} as IMarketingPage;
    readonly pageType: string = Constants.MARKETING_PAGE_TYPE_HCP;

    constructor(loggerService: LoggerService,
                userService: UserService,
                private route: ActivatedRoute,
                private marketingPageFactoryService: MarketingPageFactoryService,
                private marketingPageService: MarketingPageService) {
        super(userService, loggerService);
    }

    ngOnInit() {
        this.getCustomerData().then(() => { // keep this for digest cycle error hack
            this.initMarketingPage();
        });
    }

    initMarketingPage() {
        this.marketingPageId = this.route.snapshot.paramMap.get("uniqueId");
        this.marketingPageService.getPage(this.marketingPageId, Constants.MARKETING_PAGE_TYPE_HCP).subscribe((page: IMarketingPage) => this.setPageData(page));
    }

    setPageData(page: IMarketingPage) {
        this.marketingPage = page;
        if (!!page && !_.isEmpty(page.modules)) {
            this.loadComponents();
        } else {
            this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.pageNotFoundComponent);
        }
    }

    loadComponents() {
        _.forEach(this.marketingPage.modules, (module: any, index: number) => {
            module.marketingPageId = this.marketingPageId;
            switch (module.type.toUpperCase()) {
                case Constants.MARKETING_PAGE_SHARE: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.shareLinkComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_HERO: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.heroComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_CHECKERBOARD: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.checkerboardComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_GALLERY: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.galleryComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_VIDEO: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.videoComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_FAQ: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.faqComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_DUO_TONE: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.duoToneComponent);
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    break;
                }
                case Constants.MARKETING_PAGE_HORIZONTAL_CARD: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.horizontalCardComponent);
                    const nextComponent = this.marketingPage.modules[index+1];
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    if (!!nextComponent && nextComponent.type === Constants.MARKETING_PAGE_GALLERY_CARDS) {
                        componentRef.instance.componentData.componentStyle = 'slim-bottom';
                    }
                    break;
                }
                case Constants.MARKETING_PAGE_GALLERY_CARDS: {
                    const componentRef = this.viewContainerRef.createComponent<any>(this.marketingPageFactoryService.galleryCardsComponent);
                    const previousComponent = this.marketingPage.modules[index-1];
                    componentRef.instance.componentData = module;
                    componentRef.instance.pageUrl = this.marketingPage.url;
                    componentRef.instance.useLocaleOverride = true;
                    if (!!previousComponent && previousComponent.type === Constants.MARKETING_PAGE_HORIZONTAL_CARD) {
                        componentRef.instance.componentData.componentStyle = 'slim-top';
                    }
                    break;
                }
                case Constants.MARKETING_PAGE_PLACEHOLDER: {
                    const componentName = module.name;
                    const Component = this.marketingPageService.getPlaceholderComponent(componentName);
                    if (Component) {
                        const componentRef = this.viewContainerRef.createComponent<any>(Component);
                        componentRef.instance.componentData = module;
                        componentRef.instance.pageUrl = this.marketingPage.url;
                        componentRef.instance.useLocaleOverride = true;
                    } else {
                        console.error(`No component factory found for ${componentName}`);
                    }
                    break;
                }
            }
        });
    }

}
